import React, { useEffect, useRef } from 'react';
import styles from './Todos.module.css';

interface TodoItem {
  todo_id: string;
  resume_interview_id: string;
  content: string;
  section: string;
  created_at: string;
  updated_at: string;
  status: 'pending' | 'completed';
  completed_at?: string;
}

interface TodosProps {
  todos: TodoItem[];
}

const Todos: React.FC<TodosProps> = ({ todos }) => {
  const todosContentRef = useRef<HTMLDivElement>(null);

  // Auto scroll to bottom when new todo is added
  useEffect(() => {
    if (todosContentRef.current) {
      todosContentRef.current.scrollTop = todosContentRef.current.scrollHeight;
    }
  }, [todos.length]);

  // Filter only pending todos for display
  const pendingTodos = todos.filter(todo => todo.status === 'pending');

  if (pendingTodos.length === 0) {
    return (
      <div className={styles.todosContainer}>
        <div className={styles.todosHeader}>
          <h3 className={styles.todosTitle}>To-dos</h3>
        </div>
        <div className={styles.todosContent} ref={todosContentRef}>
          <div className={styles.emptyState}>
            <p className={styles.emptyStateText}>No todos yet</p>
            <p className={styles.emptyStateSubtext}>Items for later review will appear here</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.todosContainer}>
      <div className={styles.todosHeader}>
        <h3 className={styles.todosTitle}>To-dos</h3>
        <span className={styles.todosCount}>({pendingTodos.length})</span>
      </div>
      
      <div className={styles.todosContent} ref={todosContentRef}>
        {pendingTodos.map((todo, index) => (
          <div key={todo.todo_id} className={styles.todoItem}>
            <div className={styles.todoNode}>
              <div className={styles.todoNumber}>
                {index + 1}
              </div>
              <div className={styles.todoInfo}>
                <span className={styles.todoContent}>{todo.content}</span>
                <span className={styles.todoSection}>{todo.section}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Todos;